import { BlogWriterClient } from '~/agents/blogWriter/client'
import { AgentKey } from '~/agents/common/common/types'
import { CustomerSupportClient } from '~/agents/customerSupport/client'
import { ExecutiveAssistantClient } from '~/agents/executiveAssistant/client'
import { AgentFacade as AgentFacadeCommon } from '~/agents/facade/common'
import { LegalAssistantClient } from '~/agents/legalAssistant/client'
import { ReceptionistClient } from '~/agents/receptionist/client'
import { SalesAssistantClient } from '~/agents/salesAssistant/client'
import { SocialMediaManagerClient } from '~/agents/socialMediaManager/client'
import { Settings } from './components/Settings'

const agentsClient = [
  BlogWriterClient,
  SocialMediaManagerClient,
  ExecutiveAssistantClient,
  CustomerSupportClient,
  LegalAssistantClient,
  SalesAssistantClient,
  ReceptionistClient,
]

const getByKey = (key: AgentKey) => {
  const agentClient = agentsClient.find(
    candidate => candidate.Agent.key === key,
  )

  const agentCommon = AgentFacadeCommon.getByKey(key)?.agentCommon

  return { agentClient, agentCommon }
}

export const AgentFacade = {
  getByKey,
  Settings,
}
